import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { GLYPH_PRESETS } from "./glyphs.js";
import { DEFAULT_ACCENT, derivePalette } from "./palette.js";
export function makeTheme({ preset = "safe", accent = DEFAULT_ACCENT } = {}) {
    return {
        palette: derivePalette(accent),
        glyphs: GLYPH_PRESETS[preset],
        preset,
        accent,
    };
}
const ThemeContext = createContext(null);
export function ThemeProvider({ children, preset, accent, }) {
    const theme = useMemo(() => {
        const args = {};
        if (preset !== undefined)
            args.preset = preset;
        if (accent !== undefined)
            args.accent = accent;
        return makeTheme(args);
    }, [preset, accent]);
    return _jsx(ThemeContext.Provider, { value: theme, children: children });
}
export function useTheme() {
    const t = useContext(ThemeContext);
    if (!t) {
        throw new Error("useTheme() called outside <ThemeProvider>. Wrap your TUI root with ThemeProvider.");
    }
    return t;
}
//# sourceMappingURL=ThemeContext.js.map